import clsx from 'clsx'

import {
  ColumnAdapter,
  ColumnConditionExpression,
  DefaultConditionOperator,
  TableAdapter,
} from '@makyoapp/makyo-common'
import { SelectDropdown } from '@makyoapp/makyo-ui'

import { useDbClientContext } from '@/context/__project__/DbClientContext'

import { getOperatorOptions } from '../../shared/condition'

export function ColumnConditionOperatorSelect({
  id,
  onChange,
  selected,
  toggleClassName,
  noToggleClassName,
  menuContainerClassName,
  noMenuContainerClassName,
  value,
  colOptions,
  table,
}: {
  id?: string
  selected: DefaultConditionOperator
  onChange: (operator: DefaultConditionOperator) => void
  menuContainerClassName?: string
  noMenuContainerClassName?: boolean
  noToggleClassName?: boolean
  toggleClassName?: string
  value: ColumnConditionExpression
  colOptions: ColumnAdapter[]
  table: TableAdapter
}) {
  const { tables } = useDbClientContext()
  const colObj = colOptions.find((c) => c.id === value.lhs)
  const options = colObj ? (Object.values(getOperatorOptions(colObj, table, tables)) as DefaultConditionOperator[]) : []

  return (
    <div className='w-full min-w-0 flex-shrink-1'>
      <SelectDropdown
        toggleClassName={clsx(!noToggleClassName && 'dark:hover:bg-slate-800!', toggleClassName)}
        id={id}
        value={selected}
        onChange={(opt) => {
          onChange(opt)
        }}
        className='w-full'
        menuContainerClassName={clsx(!noMenuContainerClassName, 'min-w-[220px]', menuContainerClassName)}
        portalMenu
        menuClassName='text-m-m dark:text-slate-300'
        menuZIndex='z-402'
        menuFullWidth={false}
        options={options}
        renderOption={(opt) => {
          const split = opt.split('-').slice(1).join(' ')
          return split.charAt(0).toUpperCase() + split.slice(1)
        }}
      />
    </div>
  )
}
